import { useState } from "react";
import background_image from "../assets/background_image.png";
import { AllPermissions, countries } from "../utils/static";
import { Link } from "react-router-dom";
import { simpleLogo, solidEmail, solidUser } from "../assets/icons";
import { eye, closedEye, passwordIcon, logo } from "../assets/icons";
import { Notify, generateUniqueRandomString } from "../utils/helpfunctions";
import { register_new_company } from "../API/axios";
import Loading from "../component/StaffifyLoading";

function Signup() {
  const [imageLoading, setImageLoading] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [url, seturl] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [name, setName] = useState("");
  const [contact, setContact] = useState("+93");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [userGotRegistered, setuserGotRegistered] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitLoading(true);

    const data = {
      companyName: companyName,
      email: adminEmail,
      firstName: name,
      lastName: name,
      middleName: "",
      customUrl: url,
      role: "Super-Admin",
      password: password,
      phoneNumber: contact,
      status: "Permanent",
      archived: false,
      accountVerified: false,
      doj: new Date().toDateString(),
      designation: "Super Admin",
      jobType: "Full Time",
      empID: `${generateUniqueRandomString(16)}`,
      permissions: AllPermissions,
    };

    await register_new_company(data)
      .then((res) => {
        if (res.data.success) {
          setuserGotRegistered(true);
        }
      })
      .catch((error) => {
        if (!error.response.data.success) {
          Notify(error.response.data.message, "error");
        }
      });

    setSubmitLoading(false);
  };

  return (
    <>
      <div
        className={`relative w-full h-screen p-8 grid place-items-center overflow-auto no-scrollbar bg-gradient-to-br from-teal to-purp`}
      >
        <div className="fixed inset-0 text-center mt-2 md:mt-4 ml-4 md:ml-8 w-[200px] h-fit z-[5]">
          <Link to="/hrm" className="text-white">
            {logo}
          </Link>
        </div>

        <div
          className={`relative w-full h-full flex justify-center items-center`}
        >
          <img
            src={background_image}
            alt="Background"
            onLoad={() => setImageLoading(false)}
            className="fixed inset-0 object-cover object-center w-full h-full hidden lg:flex"
          />

          {userGotRegistered && (
            <div className="z-10 h-fit rounded-md flex flex-col gap-3 md:gap-3.5 text-sm text-black backdrop-blur-md bg-white">
              <div className="max-w-lg mx-auto mt-1 p-6 md:p-8 bg-white rounded shadow-md">
                <h2 className="text-2xl font-semibold mb-1">Welcome Aboard!</h2>
                <h2 className="text-xl font-semibold mb-4">
                  Your Organization Registration is Underway.
                </h2>

                <p className="mb-4 font-semibold">Dear {name},</p>
                <p className="mb-4">
                  We are thrilled to inform you that your organization
                  registration has been successfully received. Welcome to our
                  growing community!
                </p>
                <p className="mb-4">
                  Your request is currently being processed on our end, and our
                  dedicated team is diligently working to verify your account.
                  We understand the importance of a seamless onboarding
                  experience, and we appreciate your trust in{" "}
                  <span className="font-semibold">SynapsivateHRM</span>.
                </p>
                <p className="mb-4">
                  Once the verification process is complete, we will notify you
                  promptly. Furthermore, as soon as your custom domain link is
                  set up, we will send you a detailed email with instructions on
                  the next steps.
                </p>
                <p className="mb-4">
                  Thank you for choosing{" "}
                  <span className="font-semibold">SynapsivateHRM</span>. We look
                  forward to providing you with an exceptional experience and
                  supporting your journey with us.
                </p>
                <p className="mb-4">Best Regards,</p>
                <p>
                  <span className="font-bold">SynapsivateHRM</span> Customer
                  Support Team
                </p>
              </div>
            </div>
          )}

          {!userGotRegistered && (
            <form
              onSubmit={handleSubmit}
              className="z-10 w-[300px] smd:w-[350px] md:w-[400px] lg:w-[400px] h-fit p-4 md:p-6 rounded-md flex flex-col gap-3 md:gap-3.5 text-sm text-black backdrop-blur-md bg-white"
            >
              <h1 className="w-full text-xl md:text-2xl tracking-wide font-semibold text-center">
                Sign Up
              </h1>

              <div className="w-full flex flex-col gap-1">
                <h1 className="gap-0.5 md:gap-1 font-semibold">
                  Organization Name <span className="text-red-600">*</span>
                </h1>
                <div className="relative flex">
                  <span className="absolute top-2.5 md:top-3 left-4 w-[18px]">
                    {simpleLogo}
                  </span>
                  <input
                    type="text"
                    id="organizationName"
                    required
                    autoComplete="off"
                    placeholder="your_organization"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="bg-transparent text-sm w-full rounded-md pl-11 md:pl-12 pr-4 py-2 border border-gray-200 focus:ring-1 focus:ring-teal focus:border-teal text-black outline-none duration-500"
                  />
                </div>
              </div>

              <div className="w-full flex flex-col gap-1">
                <h1 className="gap-0.5 md:gap-1 font-semibold">
                  Select Installation Url{" "}
                  <span className="text-red-600">*</span>
                </h1>

                <div className="relative flex items-center bg-teal rounded-md px-4 text-white gap-2">
                  https://
                  <input
                    type="text"
                    id="installationUrl"
                    required
                    autoComplete="off"
                    placeholder="your_organization"
                    pattern="^[a-z]+$"
                    value={url}
                    onChange={(e) => {
                      let v = e.target.value
                        .toLowerCase()
                        .replace(/[^a-z]/g, "");
                      if (v === "www") {
                        v = "";
                      }
                      seturl(v);
                      setAdminEmail("admin@" + v + ".com");
                    }}
                    className="w-full border border-gray-200 text-sm px-2 md:px-4 py-2 bg-white focus:ring-1 focus:ring-teal focus:border-teal text-black outline-none duration-500"
                  />
                  .synapsivate.com
                </div>
              </div>

              <div className="w-full flex flex-col gap-1">
                <h1 className="gap-0.5 md:gap-1 font-semibold">
                  Super Admin Login Email{" "}
                  <span className="text-red-600">*</span>
                </h1>
                <div className="relative flex">
                  <span className="absolute top-2.5 left-4 w-[18px]">
                    {solidEmail}
                  </span>
                  <input
                    type="text"
                    id="organizationEmail"
                    required
                    autoComplete="off"
                    placeholder="admin@your_organization.com"
                    value={adminEmail}
                    onChange={(e) => setAdminEmail(e.target.value)}
                    className="bg-transparent text-sm w-full rounded-md pl-11 md:pl-12 pr-4 py-2 border border-gray-200 focus:ring-1 focus:ring-teal focus:border-teal text-black outline-none duration-500"
                  />
                </div>
              </div>

              <div className="w-full flex flex-col gap-1">
                <h1 className="gap-0.5 md:gap-1 font-semibold">
                  Password <span className="text-red-600">*</span>
                </h1>
                <div className="relative flex">
                  <span className="absolute top-2 md:top-2.5 left-4 w-5">
                    {passwordIcon}
                  </span>
                  <input
                    type={isVisible ? "text" : "password"}
                    id="password"
                    required
                    autoComplete="off"
                    placeholder="•••••••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="bg-transparent text-sm w-full rounded-md px-11 md:px-12 py-2 border border-gray-200 focus:ring-1 focus:ring-teal focus:border-teal text-black outline-none duration-500"
                  />
                  <span
                    className="absolute top-3.5 right-3 cursor-pointer opacity-70 w-5"
                    onClick={() => setIsVisible(!isVisible)}
                  >
                    {isVisible ? closedEye : eye}
                  </span>
                </div>
              </div>

              <div className="w-full flex flex-col gap-1">
                <h1 className="gap-0.5 md:gap-1 font-semibold">
                  Your Name <span className="text-red-600">*</span>
                </h1>
                <div className="relative flex">
                  <span className="absolute top-2.5 left-4 w-4">
                    {solidUser}
                  </span>
                  <input
                    type="text"
                    id="yourName"
                    required
                    autoComplete="off"
                    placeholder="Your full name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="bg-transparent text-sm w-full rounded-md pl-11 md:pl-12 pr-4 py-2 border border-gray-200 focus:ring-1 focus:ring-teal focus:border-teal text-black outline-none duration-500"
                  />
                </div>
              </div>

              <div className="w-full flex flex-col gap-1">
                <h1 className="gap-0.5 md:gap-1 font-semibold">
                  Contact Number <span className="text-red-600">*</span>
                </h1>

                <div className="relative flex">
                  <select
                    onChange={(e) => setContact(e.target.value)}
                    className="max-w-[170px] border border-gray-200 rounded-l-md outline-none focus:ring-1 focus:border-teal focus:ring-teal duration-500 px-2"
                  >
                    {countries.map((cou, index) => (
                      <option key={index} value={cou.split(",")[1]}>
                        {cou.split(",")[0]}
                      </option>
                    ))}
                  </select>

                  <input
                    type="contact"
                    id="contact"
                    required
                    autoComplete="off"
                    placeholder="123456789"
                    value={contact}
                    onChange={(e) =>
                      setContact(e.target.value.replace(/[^0-9+-]/g, ""))
                    }
                    className="w-full bg-transparent text-sm rounded-r-md px-2 md:px-4 py-2 border focus:ring-1 focus:ring-teal focus:border-teal text-black outline-none duration-500"
                  />
                </div>
              </div>

              <div className="w-full flex gap-1 justify-end text-right text-xs">
                Already registered ?
                <Link to="/hrm/login" className="font-bold text-teal underline">
                  Login Here
                </Link>
              </div>

              <button
                type="submit"
                disabled={submitLoading}
                className="w-full h-10 rounded-md bg-teal text-white font-semibold flex items-center justify-center"
              >
                {submitLoading ? (
                  <div className="flex items-center gap-2 text-base font-normal">
                    <div className="w-6 h-6 rounded-full border border-white border-t-transparent animate-spin"></div>
                    Loading please wait...
                  </div>
                ) : (
                  "Register"
                )}
              </button>
            </form>
          )}
        </div>
      </div>

      {imageLoading && <Loading />}
    </>
  );
}

export default Signup;
